import React from 'react'
import { Upload, Image } from 'antd'
import { UploadOutlined, DownloadOutlined } from '@ant-design/icons'

const CatalogUpdateCard = ({
  image,
  isReadOnly,
  onUpload,
  onDelete,
  onDownload,
}) => {
  const uploadButton = (
    <div style={{ textAlign: 'center' }}>
      <UploadOutlined style={{ fontSize: 18, color: '#1890ff' }} />
      <div style={{ marginTop: 4, color: '#999', fontSize: '11px' }}>Subir</div>
    </div>
  )

  return (
    <div className="catalog-update-card">
      <div className="catalog-update-card-header">
        <span className="catalog-update-card-title">Actualización Catálogo</span>
      </div>
      <div className="catalog-update-card-body">
        {!image?.signed_url ? (
          <Upload
            listType="picture-card"
            showUploadList={false}
            beforeUpload={(file) => {
              onUpload(file)
              return false
            }}
            className="compact-upload"
            disabled={isReadOnly}
          >
            {uploadButton}
          </Upload>
        ) : (
          <div className="catalog-image-wrapper">
            <Image src={image.signed_url} alt={image.nombre_objeto || 'catalogo'} />
            <div className="image-actions-container">
              <button
                className="download-image-button"
                type="button"
                onClick={() => onDownload(image.signed_url, image.nombre_objeto)}
                title="Descargar imagen"
              >
                <DownloadOutlined />
              </button>
              {!isReadOnly && (
                <button
                  className="delete-image-button"
                  type="button"
                  onClick={onDelete}
                >
                  Eliminar
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default CatalogUpdateCard
